import { render, staticRenderFns } from "./UnjoinTip.vue?vue&type=template&id=05adecd7&scoped=true"
import script from "./UnjoinTip.vue?vue&type=script&lang=js"
export * from "./UnjoinTip.vue?vue&type=script&lang=js"
import style0 from "./UnjoinTip.vue?vue&type=style&index=0&id=05adecd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05adecd7",
  null
  
)

export default component.exports